import { render, staticRenderFns } from "./CostPivot.vue?vue&type=template&id=fa868102"
import script from "./CostPivot.vue?vue&type=script&lang=js"
export * from "./CostPivot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports